import type { UUID } from '@cmg/common';
import { useCallback } from 'react';

import type { CrmManagement_FirmsSalesCoverageGridQueryVariables } from '../graphql/__generated__';
import {
  useCrmManagement_AdminFirmsSalesCoverageGridLazyQuery,
  useCrmManagement_FirmsSalesCoverageGridLazyQuery,
} from '../graphql/__generated__';

export function useFirmsSalesCoverageQuery(tenantId?: UUID) {
  const [loadRowsCustomer] = useCrmManagement_FirmsSalesCoverageGridLazyQuery();
  const [loadRowsAdmin] = useCrmManagement_AdminFirmsSalesCoverageGridLazyQuery();

  return useCallback(
    async (variables: CrmManagement_FirmsSalesCoverageGridQueryVariables) => {
      if (tenantId) {
        const response = await loadRowsAdmin({
          variables: {
            ...variables,
            tenantId,
          },
          fetchPolicy: 'no-cache',
        });
        return {
          ...response,
          data: {
            ...response.data,
            investorFirmsGrid: response.data?.adminInvestorFirmsGrid,
          },
        };
      } else {
        return await loadRowsCustomer({
          variables,
          fetchPolicy: 'no-cache',
        });
      }
    },
    [loadRowsAdmin, loadRowsCustomer, tenantId]
  );
}
